import { render } from "./onlineorderlist.vue?vue&type=template&id=2e9619ac"
import script from "./onlineorderlist.vue?vue&type=script&lang=js"
export * from "./onlineorderlist.vue?vue&type=script&lang=js"

import "./onlineorderlist.vue?vue&type=style&index=0&id=2e9619ac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__